<main class="contact">

  <!-- Hero -->
  <section class="contact-hero">
    <div class="contact-hero-inner">
      <span class="contact-eyebrow">
        <span class="contact-eyebrow-tag">Contact</span>
        Replies within 1–2 business days
      </span>
      <h1>Got a question?<br>We're <span class="contact-accent">here to help.</span></h1>
      <p class="contact-lede">
        Questions about the product, partnership opportunities, bug reports, or feature
        ideas — drop a line below.
      </p>
    </div>
  </section>

  <!-- Form / Success card -->
  <section class="contact-section">
    <div class="contact-form-wrap">

      @if (submitted) {
        <div class="contact-success">
          <div class="contact-success-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 12l2 2 4-4"/>
              <circle cx="12" cy="12" r="10"/>
            </svg>
          </div>
          <h2>Message sent.</h2>
          <p>Thanks for reaching out — we'll respond within 1–2 business days.</p>
          <button mat-stroked-button (click)="resetForm()">Send another message</button>
        </div>
      } @else {
        <form [formGroup]="form" (ngSubmit)="submit()" class="contact-form">

          <div class="contact-form-row">
            <mat-form-field appearance="outline" class="contact-field">
              <mat-label>Name</mat-label>
              <input matInput formControlName="name" maxlength="255">
              @if (form.get('name')?.hasError('required') && form.get('name')?.touched) {
                <mat-error>Name is required</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="contact-field">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" type="email" maxlength="255">
              @if (form.get('email')?.hasError('required') && form.get('email')?.touched) {
                <mat-error>Email is required</mat-error>
              } @else if (form.get('email')?.hasError('email') && form.get('email')?.touched) {
                <mat-error>Enter a valid email address</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="contact-form-row">
            <mat-form-field appearance="outline" class="contact-field">
              <mat-label>Phone (optional)</mat-label>
              <input matInput formControlName="phone" maxlength="50">
            </mat-form-field>

            <mat-form-field appearance="outline" class="contact-field">
              <mat-label>Company (optional)</mat-label>
              <input matInput formControlName="company" maxlength="255">
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="contact-field-full">
            <mat-label>Subject</mat-label>
            <mat-select formControlName="subject">
              @for (s of subjects; track s.value) {
                <mat-option [value]="s.value">{{ s.label }}</mat-option>
              }
            </mat-select>
            @if (form.get('subject')?.hasError('required') && form.get('subject')?.touched) {
              <mat-error>Please select a subject</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="contact-field-full">
            <mat-label>Message</mat-label>
            <textarea matInput formControlName="message" rows="5" maxlength="500"></textarea>
            <mat-hint align="end">{{ messageLength }}/500</mat-hint>
            @if (form.get('message')?.hasError('required') && form.get('message')?.touched) {
              <mat-error>Message is required</mat-error>
            }
          </mat-form-field>

          @if (error) {
            <div class="contact-error">{{ error }}</div>
          }

          <div class="contact-actions">
            <button
              mat-flat-button
              color="primary"
              type="submit"
              class="contact-submit"
              [disabled]="submitting"
            >
              @if (submitting) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                Send message
              }
            </button>
          </div>

          <p class="contact-recaptcha">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Privacy Policy</a> and
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener">Terms of Service</a> apply.
          </p>
        </form>
      }

    </div>
  </section>

</main>
